import React, { useEffect, useRef, useState } from "react";
import { createPopper } from "@popperjs/core";
import { createPortal } from "react-dom";
import styles from "./ActionDropdown.module.css";

const ActionDropdown = ({ 
    row, 
    index, 
    isOpen, 
    onToggle, 
    onSelect,
    dropdownRef,
    rowIndex 
}) => {
    const ulRef = useRef(null);
    const popperInstanceRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const referenceElement = dropdownRef?.current?.[rowIndex];
        
        if (!isOpen || !referenceElement || !ulRef.current) {
            setIsVisible(false);
            return;
        }

        // Destroy existing popper instance if it exists
        if (popperInstanceRef.current) {
            popperInstanceRef.current.destroy();
            popperInstanceRef.current = null;
        }

        // Create popper instance
        popperInstanceRef.current = createPopper(referenceElement, ulRef.current, {
            placement: 'bottom-start',
            modifiers: [
                {
                    name: 'flip',
                    options: {
                        fallbackPlacements: ['top-start', 'bottom-end', 'top-end'],
                    },
                },
                {
                    name: 'offset',
                    options: {
                        offset: [8, 8],
                    },
                },
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: 'viewport',
                        padding: 8,
                    },
                },
            ],
        });

        // Force update to calculate position
        popperInstanceRef.current.update();
        
        // Small delay to ensure position is calculated before showing
        requestAnimationFrame(() => {
            setIsVisible(true);
        });

        // Обработка клика вне дропдауна
        const handleClickOutside = (event) => {
            if (
                ulRef.current && 
                !ulRef.current.contains(event.target) &&
                referenceElement && 
                !referenceElement.contains(event.target)
            ) {
                onToggle();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            if (popperInstanceRef.current) {
                popperInstanceRef.current.destroy();
                popperInstanceRef.current = null;
            }
            document.removeEventListener('mousedown', handleClickOutside);
            setIsVisible(false);
        };
    }, [isOpen, dropdownRef, rowIndex, onToggle]);

    const handleOptionClick = (option) => {
        onSelect(option);
    };

    return (
        <>
            <td 
                className={`${styles.customDropdown} ${styles.actionCell}`} 
                ref={(el) => dropdownRef.current[rowIndex] = el}
            >
                <p onClick={onToggle}>
                    {row.action?.title || <span>{row.action}</span>}
                </p>
            </td>
            {isOpen && createPortal(
                <ul 
                    ref={ulRef}
                    className={`${styles.dropdownList} ${isVisible ? styles.visible : ''}`}
                >
                    {row.options.map((option, optionIndex) => (
                        <li
                            key={optionIndex}
                            onClick={() => handleOptionClick(option)}
                        >
                            {option.id <= 14 ? `${option.id}. ${option.title}` : `${option.id - 14}. ${option.title}`}
                        </li>
                    ))}
                </ul>,
                document.body
            )}
        </>
    );
};

export default ActionDropdown;